// 发送预览数据，用于后续的统计
export function previewData(id,classId,previewAddress,name,url = "",startTime = new Date().getTime()) {
	let previewData = {}
	previewData.id = id;
	previewData.startTime = startTime;
	previewData.classId = classId;
	previewData.previewAddress = previewAddress;
	previewData.name = name;
	previewData.url = url;

	return previewData;
}



// WEBPACK FOOTER //
// ./src/components/pageRouter/bean/previewData.js